import React from 'react';
import Header from '../../../components/layout/headers/Header'
import DynamicNavigation from "../../../components/layout/navigation/DynamicNavigation"
import CreateNewPolicyPage from "./create/CreateNewPolicyPage"

const ApplyPolicy = () => {

    return (
        <>
            <Header />
            <DynamicNavigation />
            <div className="min-h-screen bg-base-200 pt-28 pb-8">
                <div className="container mx-auto px-4 max-w-7xl">
                    <CreateNewPolicyPage className="mt-2 m-auto" existingApplicationProgress={{applicationDetail:null}} isLifePolicy={true} />
                </div>
            </div>
        </>
    );

};

export default ApplyPolicy;